import { Component, EventEmitter, OnInit, Output, Input, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
    selector: 'eui-dashboard-card',
    templateUrl: './eui-dashboard-card.component.html',
    styleUrls: ['./styles/_index.scss'],
})
export class EuiDashboardCardComponent implements OnInit {
    @Input() styleClass: string;
    @Input() typeClass: string;
    @Input() iconClass: string;
    @Input() iconTypeClass: string;
    @Input() imageUrl: string;
    @Input() imageWidth = '64';
    @Input() imageHeight = '64';
    @Input() isIconCompact = true;
    @Input() label: string;
    @Input() subLabel: string;
    @Input() urlExternal: string;
    @Input() urlExternalTarget = '_blank';
    @Input() url: string;
    @Input() buttonLinkLabel: string;
    @Input() buttonStyleClass = 'btn-info';
    @Input() isClickable = false;
    @Input() isHorizontalLayout = false;

    @Input() labelMaxLines: string;
    @Input() subLabelMaxLines: string;

    @Input() e2eAttr = 'eui-dashboard-card';

    @Output() onClicked: EventEmitter<any> = new EventEmitter<any>();

    constructor(private router: Router) {
    }

    ngOnInit() {
    }

    get stateTypeClass(): string {
        let classes = '';

        if (this.typeClass) {
            classes = 'eui-dashboard-card--' + this.typeClass;
        }

        return classes;
    }

    onKeyDown(keyCode: number) {
        if (this.isClickable && keyCode === 13) {
            this.openLink();
        }
    }

    onClick(event: any) {
        if (this.isClickable) {
            this.openLink();
            this.onClicked.emit(event);
        }
    }

    openLink() {
        if (this.url) {
            this.router.navigate([this.url]);
        }
        if (this.urlExternal) {
            window.open(this.urlExternal, this.urlExternalTarget);
        }
    }

}

@NgModule({
    imports: [CommonModule, RouterModule],
    exports: [EuiDashboardCardComponent],
    declarations: [EuiDashboardCardComponent],
})
export class EuiDashboardCardModule {
}
